import { ScheduleRequest } from '@weave/schema-gen-ts/dist/schemas/schedule/api/v2/api.pb';
import { isEmpty } from 'lodash-es';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { getFullName } from '@frontend/name';
import { ScheduleRequestListItem } from '@frontend/schedule-helpers';
import { useModalControl } from '@frontend/design-system';
import { useCheckPaymentsEnabled } from '../../../../../../../hooks/use-check-payments-enabled';
import { PreferenceBasedScheduleRequestItemHeader } from './preference-based-item-header';
import { ScheduleRequestListItemHeader } from './schedule-request-item-header';

export type ScheduleRequestItemHeaderProps = {
  isWidgetListItem?: boolean;
  listItem: ScheduleRequestListItem;
  setSelectedScheduleRequest: React.Dispatch<React.SetStateAction<ScheduleRequest | null>>;
  scheduleRequestModalProps: ReturnType<typeof useModalControl>;
  locationChip?: (locationName: string) => React.ReactNode;
  patientContactedAt?: string;
  deleteRequestModalProps: ReturnType<typeof useModalControl>;
  dismissRequestModalProps: ReturnType<typeof useModalControl>;
  rejectRequestModalProps: ReturnType<typeof useModalControl>;
  onCompleteRequest: () => void;
  onMessage: (updateStatus: boolean) => void;
  onPhoneCall: () => void;
};

export const ScheduleRequestItemHeader = ({
  isWidgetListItem,
  listItem,
  setSelectedScheduleRequest,
  scheduleRequestModalProps,
  locationChip,
  patientContactedAt,
  deleteRequestModalProps,
  dismissRequestModalProps,
  rejectRequestModalProps,
  onCompleteRequest,
  onMessage,
  onPhoneCall,
}: ScheduleRequestItemHeaderProps) => {
  const { isPaymentsEnabled } = useCheckPaymentsEnabled(listItem.locationId);
  const { isPreferenceBasedRequestEnabled } = SchedulerV3.Helpers.useGetPreferenceBasedRequestFeatureFlagDetails();
  const isPreferenceBasedRequest = !isEmpty(listItem.aiRequestDetails);

  const sharedProps = {
    requestVersion: listItem.linkHash || '',
    name: getFullName(listItem.schedulee ?? {}),
    appointmentTime: listItem?.dateTime ?? '',
    personPhone: listItem?.schedulee?.phoneNumber ?? '',
    locationId: listItem.locationId ?? '',
    scheduleRequestId: listItem.id ?? '',
    isWidgetListItem,
    locationChip,
  };

  const updateSelectedScheduleRequest = () => {
    if (isPreferenceBasedRequestEnabled && isPreferenceBasedRequest) {
      // TODO: Handle widget action
    } else {
      setSelectedScheduleRequest(listItem);
      scheduleRequestModalProps.openModal();
    }
  };

  return isPreferenceBasedRequestEnabled && isPreferenceBasedRequest ? (
    <PreferenceBasedScheduleRequestItemHeader
      {...sharedProps}
      aiRequestDetails={listItem.aiRequestDetails}
      patientContactedAt={patientContactedAt}
      deleteRequestModalProps={deleteRequestModalProps}
      dismissRequestModalProps={dismissRequestModalProps}
      onCompleteRequest={onCompleteRequest}
      onMessage={onMessage}
      onPhoneCall={onPhoneCall}
    />
  ) : (
    <ScheduleRequestListItemHeader
      {...sharedProps}
      paidAmount={isPaymentsEnabled && listItem?.bookingAmount ? listItem?.bookingAmount : 0}
      updateSelectedScheduleRequest={updateSelectedScheduleRequest}
      deleteRequestModalProps={deleteRequestModalProps}
      rejectRequestModalProps={rejectRequestModalProps}
      onMessage={onMessage}
    />
  );
};
